import { array } from '@ember/helper';
import { action } from '@ember/object';
import { later, next, schedule } from '@ember/runloop';
import Component from '@glimmer/component';

import $ from 'jquery';

import joinClasses from 'webapp/helpers/join-classes';
import didUpdate from 'webapp/modifiers/did-update';
import FormInputComponent from 'webapp/components/form/input';

import type CustomMetricSetupFormSheet from 'webapp/models-custom/custom-metric-setup-form/sheet';

export interface Args {
	form: CustomMetricSetupFormSheet;
	name: string; // 'metric' | 'date' | 'dimension'
	value: string;
	placeholder: string;
	isFocused: boolean;
	hasValue: boolean;
	isDisabled: boolean;
	onItemAction: (actionName: string) => void;
}

export default class FormInputA1Component extends Component<Args> {
	get color() {
		return (
			this.args.form.getColorForA1Field(this.args.name as 'metric' | 'date' | 'dimension') ||
			''
		);
	}

	get colorClass() {
		return `color-${this.color.substr(1)}`;
	}

	@action
	scheduleUpdateFloatlabels(node: HTMLElement) {
		schedule('afterRender', () => {
			// using jquery bcos native dispatchEvent initiates infinite loop
			$(node).find('input').trigger('change');
		});
	}

	@action
	focusIn() {
		this.args.onItemAction('focus-in');
	}

	@action
	focusOut() {
		next(this, function () {
			// later because in this time we are triggering specific cases
			// where field should not be unfocused (e.g. sheet collapser, focus on handsontable)
			later(
				this,
				function () {
					this.args.onItemAction('focus-out');
				},
				300,
			);
		});
	}
	<template>
		<div
			class={{joinClasses
				(array
					"input-a1"
					(if @isFocused "focused")
					(if @hasValue "hasValue" "noValue")
					this.colorClass
				)
			}}
			{{didUpdate this.scheduleUpdateFloatlabels @value}}
		>
			<FormInputComponent
				name={{@name}}
				@value={{@value}}
				placeholder={{@placeholder}}
				disabled={{@isDisabled}}
				@focusIn={{this.focusIn}}
				@focusOut={{this.focusOut}}
				@theme="dark"
			/>
		</div>
	</template>
}
